import { useEffect, useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';

interface SearchBarProps {
  size?: 'sm' | 'md' | 'lg';
  defaultValue?: string;
  placeholder?: string;
  className?: string;
  onSubmitted?: () => void;
}

const sizeMap = {
  sm: { wrap: 'h-9', input: 'text-sm', icon: 'text-sm' },
  md: { wrap: 'h-11', input: 'text-sm', icon: 'text-base' },
  lg: { wrap: 'h-12', input: 'text-base', icon: 'text-lg' },
};

export default function SearchBar({
  size = 'md',
  defaultValue = '',
  placeholder = '搜索影视名称、类型或资讯...',
  className = '',
  onSubmitted,
}: SearchBarProps) {
  const [value, setValue] = useState(defaultValue);
  const navigate = useNavigate();
  const cls = sizeMap[size];

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const keyword = value.trim();
    if (!keyword) return;
    navigate(`/search?q=${encodeURIComponent(keyword)}`);
    if (onSubmitted) onSubmitted();
  };

  return (
    <form onSubmit={handleSubmit} className={`relative w-full ${className}`} role="search">
      <i
        className={`ri-search-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 ${cls.icon}`}
      />
      <input
        type="search"
        name="keyword"
        value={value}
        onChange={(event) => setValue(event.target.value)}
        placeholder={placeholder}
        aria-label="搜索影视与资讯"
        className={`w-full rounded-md border border-background-300 bg-background-50 pl-9 pr-20 ${cls.wrap} ${cls.input} text-foreground-900 placeholder:text-foreground-400 outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-400/30`}
      />
      <button
        type="submit"
        className="absolute right-1 top-1/2 -translate-y-1/2 whitespace-nowrap rounded-md bg-primary-600 px-3 py-1.5 text-xs font-medium text-background-50 transition-colors hover:bg-primary-700 cursor-pointer"
      >
        搜索
      </button>
    </form>
  );
}